'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPermDeviceInformation = function MdPermDeviceInformation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 31.6v-23.2h-16.8v23.2h16.8z m0-29.9q1.3 0 2.3 1t0.9 2.3v30q0 1.3-0.9 2.3t-2.3 1.1h-16.8q-1.3 0-2.3-1.1t-0.9-2.3v-30q0-1.3 0.9-2.3t2.3-1.1z m-6.8 16.7v10h-3.2v-10h3.2z m0-6.8v3.4h-3.2v-3.4h3.2z' })
        )
    );
};

exports.default = MdPermDeviceInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/perm-device-information.js
// module id = 1300
// module chunks = 36573943044255 79611799117203 213534597649335